var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22397 10.2923C9.86564 9.13398 11.099 8.45065 11.8156 7.42565C12.574 6.35065 12.149 4.34232 9.99897 4.34232C8.59064 4.34232 7.89897 5.40898 7.60731 6.29232L5.44897 5.38398C6.04064 3.60898 7.64897 2.08398 9.99064 2.08398C11.949 2.08398 13.2906 2.97565 13.974 4.09232C14.5573 5.05065 14.899 6.84232 13.999 8.17565C12.999 9.65065 12.0406 10.1007 11.524 11.0507C11.3156 11.434 11.2323 11.684 11.2323 12.9173H8.82397C8.81564 12.2673 8.71564 11.209 9.22397 10.2923ZM11.6656 16.2507C11.6656 17.1673 10.9156 17.9173 9.99897 17.9173C9.08231 17.9173 8.33231 17.1673 8.33231 16.2507C8.33231 15.334 9.08231 14.584 9.99897 14.584C10.9156 14.584 11.6656 15.334 11.6656 16.2507Z",
    fill: "#989CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconQuestion);
export default __webpack_public_path__ + "static/media/info_icon_question.dbc2fdc20f1c60452032ccd0a6616a7a.svg";
export { ForwardRef as ReactComponent };